import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { createStore } from "redux";
import { Provider } from "react-redux";
import reducer from "./common/reducers/MainReducer";
import httpService from "./api/HttpClient";
import { Route, Redirect, BrowserRouter } from "react-router-dom";
import LoginComponent from "./modules/login/LoginComponent";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import ForbidenComponent from "./modules/error/ForbidenComponent";
import ConfirmEmailComponent from "./modules/login/ConfirmEmailComponent";
import ResetPasswordComponent from "./modules/login/ResetPasswordComponent";
import VacancyApplicationDocumentVerification from "./modules/vacancyApplication/documentVerification/VacancyApplicationDocumentVerification";

const theme = createMuiTheme({
  palette: {
    primary: {
      // light: will be calculated from palette.primary.main,
      main: "#2b84c0",
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
    secondary: {
      main: "#C0392B",
      // dark: will be calculated from palette.secondary.main,
    },
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: 3,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: 0.2,
  },
});

const store = createStore(reducer);
httpService.setupInterceptors(store);

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter basename="/konkursi/">
      {/* ======================= LOGIN/SECURITY ROUTES ======================= */}
      <Route path="/login" component={LoginComponent} />
      <Route
        exact={true}
        path="/confirmemail/:token"
        component={ConfirmEmailComponent}
      />
      <Route
        exact={true}
        path="/resetPassword/:token"
        component={ResetPasswordComponent}
      />

      <Route
        path="/app"
        render={() =>
          !localStorage.getItem("accessToken") &&
          !localStorage.getItem("currentUser") ? (
            <Redirect to="/login" />
          ) : (
            <ThemeProvider theme={theme}>
              <App />
            </ThemeProvider>
          )
        }
      />
      {/* ======================= ERRORS ROUTE ======================= */}
      <Route exact path="/error/403" component={ForbidenComponent} />
      <Route exact path="/" render={() => <Redirect to="/app/dashboard" />} />
      {/* ======================= GENERATED DOCUMENT VERIFICATION ROUTES ======================= */}
      <Route
        path="/vacancyAppDocs/verify"
        component={VacancyApplicationDocumentVerification}
      />
    </BrowserRouter>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
